class Cookies {
	constructor() {
		this.options = []
	}
	setOptions(options) {
		this.options = options;
	}
	/**
	 * Get cookie
	 * @param {string} cName
	 */
	getCookie(cName) {
		const matches = document.cookie.match(new RegExp(
			"(?:^|; )" + cName.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"
		));
		return matches ? decodeURIComponent(matches[1]) : undefined;
	}
	/**
	 * Set cookie with life-time in hours.
	 *
	 * @param {string} cName
	 * @param {string} cValue
	 * @param {number} exHours
	 */
	setCookie(cName, cValue, exHours = 1) {
		const date = new Date();
		date.setTime(date.getTime() + (exHours * 60 * 60 * 1000));

		const expires = "expires=" + date.toUTCString();
		document.cookie = encodeURIComponent(cName) + "=" + encodeURIComponent(cValue) + ";" + expires + ";path=/" ;
	}
	/**
	 * checkCookies checks if there are cookies and runs the function
	 */
	checkCookies(name, fn, arg) {
		const someCookie = this.getCookie(`${name}`);
		if (!someCookie || someCookie === 'false') {
			fn.apply(this, arguments)
		}
	}

	// checks consent to the use of cookies
	checkAgree() {
		for (let i = 0; i < this.options.length; i++) {
			if (this.getCookie(this.options[i].key) === this.options[i].value) {
				return true;
			}
		}

		return false;
	}

	// sets consent to the processing of cookies
	async installAgree() {
		try {
			/*  пока уберу это, не понятна и не логична проверка:
				получается, будет true если хотя бы одна кука принята,это не правильно
			*/
			//if (this.checkAgree()) return;
			for (let i = 0; i < this.options.length; i++) {
				this.setCookie(this.options[i].key, this.options[i].checked ? this.options[i].value : "N", 5000);
			}
		} catch (e) {
			return e
		}
	}
}
export default new Cookies();